import { render } from "./StarActivationDialog.vue?vue&type=template&id=1f425fb9&scoped=true&ts=true"
import script from "./StarActivationDialog.vue?vue&type=script&lang=ts"
export * from "./StarActivationDialog.vue?vue&type=script&lang=ts"

import "./StarActivationDialog.vue?vue&type=style&index=0&id=1f425fb9&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f425fb9"]])

export default __exports__